document.addEventListener('DOMContentLoaded', function () {
  const accountNavItem = document.querySelector('#LevoHeaderAccountTogglee');
  const kHub = document.getElementById('k-hub');

  if (accountNavItem && kHub) {
    accountNavItem.addEventListener('click', function (e) {
      // Only trigger if clicking the button/icon, not a dropdown link
      const clickedLink = e.target.closest('a[href]');
      if (clickedLink) return;

      e.preventDefault();
      kHub.style.display = 'block'; // or toggle a class
    });
  }
});

if (typeof LevoNavigationHeader !== "function") {
  class LevoNavigationHeader extends HTMLElement {
    constructor() {
      super();

      this.headerContent = document.querySelector("[data-main-header]");
      this.accountButton = this.querySelector("[data-account-toggle]");
      this.accountMenu = this.querySelector("[data-acount-menu]");
      this.announcementBar = document.querySelector(".shopify-section--announcement-bar");

      this.mobileMenuHandlers = this.querySelectorAll("[data-menu-mobile-toggle]");
      this.menuMobile = document.getElementById("mobileMenu");

      this.mobileMenuDismiss = this.querySelectorAll("[data-menu-mobile-dismiss]");

      if (this.accountButton) {
        this.accountButton.addEventListener("mouseenter", (e) => {
          e.preventDefault();
          this.toggleMenuAcount("show");
        });

        this.accountButton.addEventListener("mouseleave", (e) => {
          e.preventDefault();
          this.toggleMenuAcount("hide");
        });
      }

      if (this.mobileMenuHandlers) {
        this.mobileMenuHandlers.forEach((element) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();
            this.showMenuMobile();
          });
        });
      }
      if (this.mobileMenuDismiss) {
        this.mobileMenuDismiss.forEach((element) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();
            this.dismissMenuMobile();
          });
        });
      }

      window.addEventListener("scroll", () => {
        const announcementBarHeight = this.announcementBar?.offsetHeight ?? 1;
        const hasClass = this.headerContent.classList.contains("header-sticking");
        const isSticking = window.scrollY > announcementBarHeight;
        if (isSticking && !hasClass) {
          this.headerContent.classList.add("header-sticking");
        } else if (!isSticking && hasClass) {
          this.headerContent.classList.remove("header-sticking");
        }
      });
    }

    toggleMenuAcount(action) {
      if (action === "show") {
        this.accountMenu.classList.add("show");
      } else {
        this.accountMenu.classList.remove("show");
      }
    }

    showMenuMobile() {
      this.menuMobile.classList.add("show");
      const handlers = document.querySelector(".levo_actions_header_buttons");

      if (document.body.classList.contains("scroll-sticky")) {
        document.documentElement.classList.add("lock");
      }
      handlers.classList.add("in-menu");
    }

    dismissMenuMobile() {
      this.menuMobile.classList.remove("show");
      document.documentElement.classList.remove("lock");
      const handlers = document.querySelector(".levo_actions_header_buttons");
      handlers.classList.remove("in-menu");
    }
  }
  if (typeof customElements.get("levo-header-nav-actions") == "undefined") {
    customElements.define("levo-header-nav-actions", LevoNavigationHeader);
  }
}

if (typeof LevoMainNavigationHeader !== "function") {
  class LevoMainNavigationHeader extends HTMLElement {
    constructor() {
      super();

      // Megamenu
      this.megaMenuHandlers = this.querySelectorAll("[data-megamenu-toggle]");
      this.megamenuIsOpen = false;

      if (this.megaMenuHandlers) {
        this.megaMenuHandlers.forEach((element) => {
          element.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation(); // importante

            const target = element.getAttribute("data-target");
            const targetElement = document.getElementById(target);
            const isOpen = targetElement.classList.contains("show");

            this.closeAllMegamenus();

            if (!isOpen) {
              element.classList.add("opened");
              targetElement.classList.add("show");
            }
          });
        });
      }

      // 🔥 CLICK OUTSIDE
      document.addEventListener("click", (e) => {
        if (!this.contains(e.target)) {
          this.closeAllMegamenus();
        }
      });
    }

    closeAllMegamenus() {
      this.megaMenuHandlers.forEach((handler) => {
        const target = handler.getAttribute("data-target");
        handler.classList.remove("opened");
        document.getElementById("LevoHeaderRewards").classList.remove('show');
        const targetElement = document.getElementById(target);
        if (targetElement) {
          targetElement.classList.remove("show");
        }
      });
    }
  }

  if (typeof customElements.get("levo-mainnavigation") == "undefined") {
    customElements.define("levo-mainnavigation", LevoMainNavigationHeader);
  }
}

if (typeof LevoMainMobileMenu !== "function") {
  class LevoMainMobileMenu extends HTMLElement {
    constructor() {
      super();

      this.acordionItem = this.querySelectorAll("[data-accordion-item]");

      if (this.acordionItem) {
        this.acordionItem.forEach((item) => {
          const title = item.querySelector("[data-accordion-title]");
          const content = item.querySelector("[data-accordion-content]");
          title.addEventListener("click", (e) => {
            e.preventDefault();

            // Verificar si el item clickeado ya está abierto
            const isOpen = content.classList.contains("in");

            // Cerrar todos los items del acordeón
            this.acordionItem.forEach((i) => {
              const c = i.querySelector("[data-accordion-content]");
              const t = i.querySelector("[data-accordion-title]");
              c.classList.remove("in");
              t.classList.remove("opened");
            });

            // Si el item clickeado no estaba abierto, abrirlo
            if (!isOpen) {
              content.classList.add("in");
              title.classList.add("opened");
            }
          });
        });
      }

      this.lvlHolder = this.querySelector("[data-level-navigation]");
      this.lvlHandler = this.querySelectorAll("[data-lvl-handler]");
      this.backLvlHandler = this.querySelectorAll("[data-back-lvl]");

      if (this.lvlHandler) {
        this.lvlHandler.forEach((ele) => {
          ele.addEventListener("click", (e) => {
            e.preventDefault();
            const lvlTarget = ele.getAttribute("data-target");
            document.getElementById("mobileMenu").classList.add("in-level");
            const lvlTargetEle = this.querySelector(`[data-lvl="${lvlTarget}"]`);
            lvlTargetEle.classList.add("in");
            const heightLvl = lvlTargetEle.offsetHeight;
            this.lvlHolder.setAttribute("style", `height:${heightLvl}px`);
          });
        });
      }

      if (this.backLvlHandler) {
        this.backLvlHandler.forEach((ele) => {
          ele.addEventListener("click", (e) => {
            e.preventDefault();
            const lvlTargetEle = this.querySelectorAll(`[data-lvl]`);
            lvlTargetEle.forEach((acc) => {
              acc.classList.remove("in");
            });
            document.getElementById("mobileMenu").classList.remove("in-level");
            this.lvlHolder.removeAttribute("style");
          });
        });
      }
    }
  }
  if (typeof customElements.get("levo-mobile-nav") == "undefined") {
    customElements.define("levo-mobile-nav", LevoMainMobileMenu);
  }
}

// Rewards
const rewardsButton = document.getElementById("LevoHeaderRewardsToggle");
const rewardsMenu   = document.getElementById("LevoHeaderRewards");

// NEW
const newButton = document.getElementById("LevoHeaderNewToggle");
const newMenu   = document.getElementById("LevoHeaderNewMenu");

function closeMenusExcept(except) {
  if (rewardsMenu && rewardsMenu !== except) rewardsMenu.classList.remove("show");
  if (newMenu && newMenu !== except) newMenu.classList.remove("show");

}

if (rewardsButton && rewardsMenu) {
  rewardsButton.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector('levo-mainnavigation').closeAllMegamenus();
    const willShow = !rewardsMenu.classList.contains("show");
    closeMenusExcept(willShow ? rewardsMenu : null);
    rewardsMenu.classList.toggle("show", willShow);
  });
}

if (newButton && newMenu) {
  newButton.addEventListener("click", (e) => {
    e.preventDefault();
    document.querySelector('levo-mainnavigation').closeAllMegamenus();
    const willShow = !newMenu.classList.contains("show");
    closeMenusExcept(willShow ? newMenu : null);
    newMenu.classList.toggle("show", willShow);
  });

  document.addEventListener("click", (e) => {
    if (
      newMenu &&
      !newMenu.contains(e.target) &&
      !newButton.contains(e.target) &&
      (!rewardsMenu || (!rewardsMenu.contains(e.target) && !rewardsButton.contains(e.target)))
    ) {
      closeMenusExcept(null);
    }
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeMenusExcept(null);
  });
}
